import { publicSiteConfig } from "@/content/company/public-config";
import { isLocale, type Locale } from "@/content/translations";
import { LANGUAGE_COOKIE } from "./locale-detection";

function rememberLanguageCookie(locale: Locale, refresh = true) {
  if (typeof document === "undefined") return;
  if (!refresh && document.cookie.split(";").some(value => value.trim() === `${LANGUAGE_COOKIE}=${locale}`)) return;
  try { document.cookie = `${LANGUAGE_COOKIE}=${locale}; Path=/; Max-Age=31536000; SameSite=Lax${window.location?.protocol === "https:" ? "; Secure" : ""}`; } catch { /* Storage restrictions must not block navigation. */ }
}

export function readLanguagePreference(): Locale | null {
  if (typeof window === "undefined") return null;

  for (const key of [
    publicSiteConfig.languagePreferenceKey,
    publicSiteConfig.legacyLanguagePreferenceKey,
  ]) {
    try {
      const stored = window.localStorage.getItem(key);
      if (!stored || !isLocale(stored)) continue;
      if (key !== publicSiteConfig.languagePreferenceKey) {
        window.localStorage.setItem(
          publicSiteConfig.languagePreferenceKey,
          stored,
        );
      }
      rememberLanguageCookie(stored, false);
      return stored;
    } catch {
      return null;
    }
  }

  return null;
}

export function writeLanguagePreference(locale: Locale) {
  if (typeof window === "undefined") return;
  rememberLanguageCookie(locale);
  try {
    window.localStorage.setItem(publicSiteConfig.languagePreferenceKey, locale);
  } catch {
    // Navigation must still work when browser storage is unavailable.
  }
}
